import {Route} from '@angular/router';
import {environment} from '../environments/environment';
import {LoginGuard} from './shared/guard/login.guard';
import {AuthGuard} from './shared/guard/auth.guard';
import {LoginAdminGuard} from './shared/guard/loginAdmin.guard';
import {AuthAdminGuard} from './shared/guard/authAdmin.guard';

export const routes: Route[] = [
    // customer
    {
        path: environment.baseAppPath,
        loadChildren: () => import('./app-starter/app-starter.routing').then(value => value.AppStarterCustomerRoutes),
        canActivate: [LoginGuard]
    },
    {
        path: environment.baseAppPath,
        loadChildren: () => import('./app-body-customer/app-body-customer.routing').then(m => m.AppBodyCustomerRouting),
        canActivate: [AuthGuard]
    },
    // admin
    {
        path: environment.baseAdminPath,
        loadChildren: () => import('./app-starter/app-starter.routing').then(value => value.AppStarterAdminRoutes),
        canActivate: [LoginAdminGuard]
    },
    {
        path: environment.baseAdminPath,
        loadChildren: () => import('./app-body-admin/app-body-admin.routing').then(m => m.AppBodyAdminRouting),
        canActivate: [AuthAdminGuard]
    },
    {
        path: '**',
        pathMatch: 'full',
        loadComponent: () => import('./shared/components/page-not-found/page-not-found.component').then(value => value.PageNotFoundComponent)
    }
];
